import { LanguageInfo } from '../configuration/config.types';
import { LanguageAction } from './language.types';

export class SetLanguage {
  static readonly type = LanguageAction.SET_LANGUAGE;
  constructor(public readonly language: LanguageInfo) {}
}

export class SetupLanguage {
  static readonly type = LanguageAction.SETUP_LANGUAGE;
  constructor(public readonly defaultLang: LanguageInfo) {}
}
